import { phone as formatPhone } from '../../utils/helpers'

// The statuses where somebody has actually been assigned. Before `accepted`
// there is no rider, and a cancelled order never got one.
export const RIDER_ASSIGNED = ['accepted', 'picked_up', 'delivered']

const initialsOf = (name) =>
  String(name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()

const firstNameOf = (name) => String(name || '').trim().split(' ')[0]

/**
 * Who is coming, and how to reach them.
 *
 * A stranger is riding to this person's house; the plate number is here so they
 * can tell which motorbike pulling up is theirs, and the call button is a real
 * tel: link rather than a control that looks live and does nothing.
 */
export default function RiderCard({ rider, status }) {
  const delivered = status === 'delivered'
  const first = firstNameOf(rider.displayName)

  return (
    <section className="mt-4 border border-hairline rounded-card overflow-hidden">
      <p className="px-4 py-3 text-label font-semibold uppercase text-ink-3 bg-surface-2 border-b border-hairline">
        {delivered ? 'Delivered by' : 'Your rider'}
      </p>

      <div className="p-4 bg-surface">
        <div className="flex items-center gap-3.5">
          {rider.photoURL ? (
            <img
              src={rider.photoURL}
              alt=""
              className="w-11 h-11 flex-none rounded-full object-cover border border-hairline"
            />
          ) : (
            <div className="w-11 h-11 flex-none rounded-full grid place-items-center bg-blush text-brand text-body font-bold">
              {initialsOf(rider.displayName)}
            </div>
          )}

          <div className="min-w-0">
            <p className="text-body font-semibold text-ink truncate">{rider.displayName}</p>
            <p className="mt-0.5 text-body-s text-ink-3">
              {rider.vehicle}
              {rider.plateNumber && (
                <>
                  {' · '}
                  <span className="tabular-nums tracking-[0.02em]">{rider.plateNumber}</span>
                </>
              )}
            </p>
          </div>
        </div>

        <a
          href={`tel:${String(rider.phoneNumber || '').replace(/[^\d+]/g, '')}`}
          className="flex items-center justify-center gap-2 w-full min-h-[44px] mt-3.5 px-4 rounded-btn
                     border border-edge bg-transparent text-ink text-body font-semibold no-underline
                     transition-colors duration-quick ease-out hover:border-brand hover:bg-blush"
        >
          <svg
            viewBox="0 0 24 24"
            className="w-[18px] h-[18px]"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M6.5 3h3l1.5 4-2 1.5a12 12 0 0 0 5.5 5.5L16 12l4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 3 6.2 2 2 0 0 1 5 4Z" />
          </svg>
          Call {first || 'the rider'}
        </a>

        <p className="mt-2 text-body-s text-ink-3 tabular-nums text-center">
          {formatPhone(rider.phoneNumber)}
        </p>
      </div>
    </section>
  )
}
